const LOCALE_BUNDLE = 'oskariui';
export const getMsg = (key) => Oskari.getMsg(LOCALE_BUNDLE, key);
